module.exports = __webpack_public_path__ + "img/NDZ_Header_Bird.b7d0e0bd.svg";